import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import store from './store'
import { isPlatform } from '@ionic/react';
import MobileWebApp from "./MobileWebApp/MobileWebApp";
import NativeApp from "./NativeApp/NativeApp";
import {RecoilRoot} from "recoil";

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <Provider store={store}>
        {isPlatform('capacitor') || process.env.REACT_APP_CLIENT_TYPE === "native"
          ? <NativeApp/>
          : <MobileWebApp />
        }
      </Provider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
